import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import NetworkHistoryTable from '../GeneralComponents/NetworkHistoryTable';
import PositionHistoryTable from '../GeneralComponents/PositionHistoryTable';
import VersionHistoryTable from '../GeneralComponents/VersionHistoryTable';
const HGeneralTab = ({ deviceHistory }) => {
    return (_jsxs(Stack, { gap: 1, children: [_jsx(NetworkHistoryTable, { networkHistory: deviceHistory?.NAS }), _jsx(PositionHistoryTable, { posHistory: deviceHistory?.location }), _jsx(VersionHistoryTable, { verHistory: deviceHistory?.version })] }));
};
export default HGeneralTab;
